import AppDispatcher from "../dispatcher/AppDispatcher";

import AppConstants from "../constants/AppConstants";

import BudgetStore from "../stores/BudgetStore";

import Api from "../utils/Api";

// BudgetActions
export default
{
	async initialize(reInitialize)
	{
		if (!BudgetStore.getIsInitialized() || !!reInitialize)
		{
			try
			{
				const [budgetAllocations, budgetTemplates] =
					await Promise.all([Api.getBudgetAllocations(), Api.getBudgetTemplates()]);

				AppDispatcher.handleAction({
					actionType: AppConstants.BUDGET_RECEIVE_DATA,
					budgetAllocations,
					budgetTemplates
				});
			}
			catch (err)
			{
				// TODO: BA-152 call a fail action
				console.log(err);
			}
		}
	},

	async transfer(transferDetails)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.BUDGET_ALLOCATIONS_TRANSFER_PENDING,
			transferDetails
		});

		try
		{
			const allocations = await Api.budgetTransfer(transferDetails);
			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_ALLOCATIONS_TRANSFER_SUCCESS,
				transferDetails,
				allocations
			});
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_ALLOCATIONS_TRANSFER_FAILURE,
				transferDetails,
				message
			});
		}
	},

	async setBudgetAllocationOrder(categoryId, sequence)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.BUDGET_ALLOCATIONS_SETORDER_PENDING
		});

		try
		{
			const budgetAllocations = await Api.setBudgetAllocationOrder(categoryId, sequence);
			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_ALLOCATIONS_SETORDER_SUCCESS,
				budgetAllocations
			});
			return budgetAllocations;
		}
		catch (message)
		{
			console.error(message);

			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_ALLOCATIONS_SETORDER_FAILURE,
				message
			});
		}
	},

	async saveBudgetTemplate(budgetTemplate)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.BUDGET_TEMPLATE_SAVE_PENDING
		});

		const isNew = !budgetTemplate.id;
		try
		{
			budgetTemplate = await Api.saveBudgetTemplate(budgetTemplate);
			console.log(`saving budget template new:${isNew} - ${JSON.stringify(budgetTemplate)}`);
			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_TEMPLATE_SAVE_SUCCESS,
				budgetTemplate,
				isNew
			});
			console.log(`saved budget template new:${isNew} - ${JSON.stringify(budgetTemplate)}`);

			return budgetTemplate;
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_TEMPLATE_SAVE_FAILURE,
				message
			});

			throw (message);
		}
	},

	deleteBudgetTemplate(id)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.BUDGET_TEMPLATE_DELETE_PENDING,
			id
		});

		return Api.deleteBudgetTemplate(id)
			.then(() => {
				AppDispatcher.handleAction({
					actionType: AppConstants.BUDGET_TEMPLATE_DELETE_SUCCESS,
					id
				});
			}).catch(message => {
				AppDispatcher.handleAction({
					actionType: AppConstants.BUDGET_TEMPLATE_DELETE_FAILURE,
					message
				});
				if (message instanceof Error)
				{
					return message;
				}
				return new Error(message);
			});
	},

	async runBudgetTemplate(id)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.BUDGET_TEMPLATE_RUN_PENDING
		});

		try
		{
			const result = await Api.runBudgetTemplate(id);
			const budgetTemplate = await Api.getBudgetTemplate(id);
			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_TEMPLATE_RUN_SUCCESS,
				budgetAllocations: result.allocations,
				budgetTemplate,
				id
			});
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.BUDGET_TEMPLATE_RUN_FAILURE,
				message
			});

			// TODO: BudgetTemplates.jsx currently relies on this throwing, it should be updated to use the store
			// TODO: add console.error(message) here when we update
			throw (message);
		}
	}
};



// WEBPACK FOOTER //
// ./Components/actions/BudgetActions.jsx